namespace TotalContest {
    import Controller = TotalCore.Common.Controller;
    import SettingsService = TotalCore.Common.Providers.SettingsService;

    @Controller('controllers.totalcontest')
    export class SidebarIntegrationCtrl {
        public sidebar;
        public sidebars;

        constructor(private ajaxEndpoint, private prefix, private SettingsService: SettingsService) {
            this.sidebars = this.SettingsService.information.sidebars || {};
        }

        addWidgetToSidebar() {
            this.sidebar.inserted = true;

            jQuery.post(
                this.ajaxEndpoint,
                {
                    action: `${this.prefix}_contests_add_to_sidebar`,
                    contest: this.SettingsService.settings.id,
                    sidebar: this.sidebar.id
                }
            ).then((response) => this.sidebar.inserted = response.success || false)
                .fail(() => this.sidebar.inserted = false);
        }
    }

}